export const content = {
  nav: {
    brand: "Uli Samson",
    about: "Über mich · About",
    offer: "Angebot · Services",
    contact: "Kontakt · Contact",
  },
  hero: {
    eyebrowDe: "Englisch- & Deutschunterricht · Online · Weltweit",
    eyebrowEn: "English & German Lessons · Online · Worldwide",
    titleDe1: "Wissen ist",
    titleDe2: "Macht.",
    titleEn: "Knowledge is Power.",
    subDe: "M.A. Universität Hamburg — Anglistik, Romanistik, Germanistik. Über 25 Jahre Erfahrung im Deutsch- und Englischunterricht. Trainingskonzepte, individuell auf Sie zugeschnitten — und sie machen Spaß.",
    subEn: "Master's degree from the University of Hamburg — English, French and German languages and literature. Over 25 years’ experience in teaching German and English. Training programmes tailored specifically to your needs — and they’re fun.",
    ctaPrimary: "Kontakt · Contact",
    ctaSecondary: "Angebot · Services",
    badge: "Online · Weltweit · Worldwide · Zoom · ",
    scroll: "Scrollen · Scroll",
    imageCaption: "Uli Samson — Hamburg · online weltweit / worldwide",
  },
  marquee: [
    "English & German",
    "Corporate & Private",
    "Online — Worldwide",
    "Translations · Übersetzungen",
    "Wissen ist Macht",
    "Knowledge is Power",
  ],
  about: {
    chapter: "Über mich · About me",
    name: "Uli Samson",
    roleDe: "Englisch- und Deutschunterricht",
    roleEn: "English & German Language Coaching",
    paragraphs: [
      {
        de: "M.A. Universität Hamburg — Studium der Sprachwissenschaften: Anglistik, Romanistik und Germanistik.",
        en: "MA, University of Hamburg: English, French and German languages and literature.",
      },
      {
        de: "Ich verfüge über 25 Jahre Erfahrung im Deutsch- und Englischunterricht. Meine Trainingskonzepte sind individuell auf Sie zugeschnitten und machen Spaß.",
        en: "I offer over 25 years’ experience in teaching German and English. My teaching programmes are tailored to your individual needs and are designed to be enjoyable.",
      },
      {
        de: "Ich verhelfe Ihnen zu einer sicheren Basis für einen professionellen Auftritt in englischer und deutscher Sprache — persönlich, präzise und mit Freude an der Sprache.",
        en: "I’ll help you build a solid foundation for a professional command of English and German — with a personal touch, attention to detail and a genuine love of language.",
      },
    ],
    facts: [
      { k: "25+", de: "Jahre Erfahrung", en: "Years of experience" },
      { k: "M.A.", de: "Universität Hamburg", en: "University of Hamburg" },
      { k: "100 %", de: "Online, weltweit", en: "Online, worldwide" },
    ],
    portraitCaption: "Firmen-Training · Corporate Training",
    libraryCaption: "Übersetzung & Lektorat · Translation & Editing",
  },
  services: {
    chapter: "Angebot · Services",
    headingDe: "Fünf Kapitel. Ein Ziel: Ihre Sprachkompetenz.",
    headingEn: "Five chapters. One goal: your language skills.",
    subDe: "Vom Firmen-Training bis zur Fachübersetzung — jedes Angebot ist maßgeschneidert. Alle Lektionen finden online weltweit oder vor Ort in Ihrer Firma in Hamburg statt, für Kundinnen und Kunden auf der ganzen Welt.",
    subEn: "From corporate training to professional translation — every offer is tailor-made. All lessons are held online world-wide or on-site in Hamburg, for clients all over the world.",
    colDe: "Deutsch",
    colEn: "English",
    enquire: "Anfragen · Enquire",
    items: [
      {
        id: "firmen",
        titleDe: "Firmen-Unterricht",
        titleEn: "Corporate Training",
        taglineDe: "Business English oder Deutsch — als Einzelunterricht oder in der Kleingruppe.",
        taglineEn: "Business English or German — one-to-one or in small groups.",
        bullets: [
          {
            de: "Ich komme zu Ihnen in die Firma — oder wir treffen uns online.",
            en: "I come to your company — or we meet online.",
          },
          {
            de: "Fokus auf freiem Sprechen und Verstehen.",
            en: "Focus on fluent speaking and comprehension.",
          },
          {
            de: "Branchenspezifisches Vokabular — etwa aus Schifffahrt, Technik, Werbung, IT, Hotel und Finanzen — ist fester Bestandteil des Business-Englisch-Unterrichts.",
            en: "Industry-specific vocabulary — from e.g. shipping, technology, advertising, IT, hospitality and finance — is an integral part of the Business English curriculum.",
          },
        ],
      },
      {
        id: "privat",
        titleDe: "Privat-Unterricht",
        titleEn: "One-to-One Lessons",
        taglineDe: "Ganz nach Ihrem Kalender — bei Ihnen, in meinem Büro in Farmsen oder online.",
        taglineEn: "Entirely around your schedule — at your place, in my office in Farmsen, or online.",
        bullets: [
          { de: "Individualität steht an erster Stelle.", en: "Individuality comes first." },
          { de: "Ich passe mich Ihrem Terminkalender an.", en: "I work around your schedule." },
          {
            de: "Lernziele sind exakt auf Sie zugeschnitten, Ihr persönliches Lernverhalten optimal berücksichtigt.",
            en: "Objectives are tailored precisely to you; your personal learning style is fully taken into account.",
          },
          { de: "Kein Zeit- oder Gruppendruck.", en: "No time pressure, no group pressure." },
        ],
      },
      {
        id: "online",
        titleDe: "Online-Unterricht",
        titleEn: "Online Lessons",
        taglineDe: "Von überall auf der Welt — zeitlich flexibel per Zoom.",
        taglineEn: "From anywhere in the world — flexible scheduling via Zoom.",
        bullets: [
          {
            de: "Sie sparen Zeit und Wege — von überall auf der Welt möglich.",
            en: "Saves you time and travel — possible from anywhere in the world.",
          },
          {
            de: "Auch für internationale Kundinnen und Kunden: Der gesamte Unterricht findet bequem online statt.",
            en: "Also for international clients: every lesson takes comfortably place online.",
          },
        ],
      },
      {
        id: "nachhilfe",
        titleDe: "Nachhilfe",
        titleEn: "Tutoring & Exams",
        taglineDe: "Professionelle Abiturvorbereitung und Nachhilfe.",
        taglineEn: "Professional A-level (Abitur) preparation and tutoring.",
        bullets: [
          {
            de: "Ich mache Ihr Kind — oder Sie — fit für das Abitur und alle anderen Englisch- und Deutschprüfungen.",
            en: "I will help your child — or you — prepare for A-levels (Abitur) and all other English and German exams.",
          },
          {
            de: "Darunter: A1/A2/B1/B2/C1/C2 Deutschprüfungen und TOEFL.",
            en: "Including: A1/A2/B1/B2/C1/C2 German certificates and TOEFL.",
          },
        ],
      },
      {
        id: "uebersetzung",
        titleDe: "Übersetzung",
        titleEn: "Translation",
        taglineDe: "Vom Englischen ins Deutsche — und umgekehrt.",
        taglineEn: "From English into German — and vice versa.",
        bullets: [
          {
            de: "Qualitativ hochwertige Fachübersetzungen fast aller Textarten — mit Rundumbetreuung.",
            en: "High-quality professional translations of almost all text types — with full support throughout.",
          },
          {
            de: "Als Ansprechpartnerin für inhaltliche Fragen stets erreichbar.",
            en: "Always available as your contact person for questions of content.",
          },
          {
            de: "Auch kurzfristige Abgabetermine nach Absprache möglich.",
            en: "Short-notice deadlines possible by arrangement.",
          },
          {
            de: "Lektorat aller Texte durch einen muttersprachlichen Lektor und Schriftsteller.",
            en: "Proofreading of all texts by a native-speaker editor and writer.",
          },
        ],
      },
    ],
  },
  testimonials: {
    chapter: "Stimmen · Voices",
    headingDe: "Was Kundinnen und Kunden sagen.",
    headingEn: "What clients say.",
    items: [
      {
        quoteDe: "»Business English, das im Arbeitsalltag funktioniert — individuell, präzise und mit viel Humor.«",
        quoteEn: "\"Business English that works in everyday working life — personalised, precise and with plenty of good humour.\"",
        authorDe: "Geschäftsführer, Logistikbranche",
        authorEn: "Managing Director, logistics",
      },
      {
        quoteDe: "»Dank der Vorbereitung von Frau Samson hat unsere Tochter das Englisch-Abitur mit Bestnote bestanden.«",
        quoteEn: "\"Thanks to Ms Samson's preparation, our daughter passed her English Abitur with top marks.\"",
        authorDe: "Mutter einer Abiturientin",
        authorEn: "Mother of an Abitur graduate",
      },
    ],
  },
  contact: {
    chapter: "Kontakt · Contact",
    headingDe: "Schreiben Sie mir.",
    headingEn: "Write to me.",
    subDe: "Sie erreichen mich telefonisch oder jederzeit per E-Mail — ich melde mich persönlich bei Ihnen.",
    subEn: "Contact me by phone or by e-mail at any time — I will get back to you personally.",
    phoneLabel: "Telefon · Phone",
    phone: "+49 (0) 176 – 482 152 13",
    emailLabel: "E-Mail",
    email: "Info@Englisch-in-Wandsbek.de",
    nameLabel: "Ihr Name · Your name",
    emailFieldLabel: "Ihre E-Mail · Your e-mail",
    messageLabel: "Ihre Nachricht · Your message",
    submit: "Senden · Send",
    sending: "Wird gesendet · Sending …",
    successDe: "Vielen Dank — Ihre Nachricht ist angekommen. Ich melde mich in Kürze bei Ihnen.",
    successEn: "Thank you — your message has arrived. I will get back to you shortly.",
    errorDe: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie direkt per E-Mail.",
    errorEn: "Something went wrong. Please try again or write to me directly by e-mail.",
  },
  footer: {
    lineDe: "Englisch in Wandsbek — Ihr Unterricht.",
    lineEn: "Englisch in Wandsbek — your lessons.",
    location: "Hamburg · Online, weltweit / worldwide",
    rights: "Alle Rechte vorbehalten · All rights reserved.",
  },
};
